import React, { useState } from 'react';
import cx from 'classnames';
import InfoTable from '../../../../../components/table/InfoTable';
import { VALID_FILTER } from '../../../../../constants/service/common/utilConstants';
import { setDash, setPhoneFormat } from '../../../../../lib/common';
import Modal from '../../../../../components/Modal/Modal';
import { ACCOUNT_USER_STATUS_TEXT } from '../../../../../constants/service/app/accountUserConstants';
import {
  INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE_TEXT,
  INVALID_BULK_GENERATE_COUPON_CASE_ISSUED_TYPE_TEXT,
  INVALID_BULK_GENERATE_COUPON_CASE_TEXT,
  INVALID_BULK_GENERATE_COUPON_CASE_TYPE_TEXT,
  INVALID_BULK_GENERATE_COUPON_CASE_USER_TYPE_TEXT,
  INVALID_BULK_GENERATE_COUPON_CASE_USER_STATUS_TYPE_TEXT,
  VALID_BULK_GENERATE_COUPON_CASE_TEXT,
} from '../../../../../constants/service/app/couponConstants';
import './GenerateCouponValidFailModal.scss';

const GenerateCouponValidFailModal = (props) => {
  const { isOpen, data, closeModal, openExcelBulkGenerateCouponModal } = props;
  const { userCouponList, requestCnt, possibleCnt, impossibleCnt, isBulk } = data;
  const [validFilterValue, setValidFilterValue] = useState(VALID_FILTER.ALL);

  const validFilter = (item) => {
    if (validFilterValue === VALID_FILTER.VALID) {
      return !(
        item.userIsInvalid ||
        item.statusIsInvalid ||
        item.cellPhoneIsInvalid ||
        item.couponIsInvalid ||
        item.issuedIsInvalid
      );
    } else if (validFilterValue === VALID_FILTER.INVALID) {
      return (
        item.userIsInvalid ||
        item.statusIsInvalid ||
        item.cellPhoneIsInvalid ||
        item.couponIsInvalid ||
        item.issuedIsInvalid
      );
    }

    return true;
  };

  return (
    <Modal
      title="쿠폰 발급 실패"
      isOpen={isOpen}
      width={1550}
      height={600}
      isFooter={true}
      okText={isBulk ? '재업로드' : '확인'}
      onOk={isBulk ? openExcelBulkGenerateCouponModal : closeModal}
      onClose={() => closeModal()}
    >
      <div className="generate-coupon-valid-fail-modal-wrap">
        <div className="generate-coupon-valid-fail-title">
          <div className="summary">
            <button
              type="button"
              className="request"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.ALL);
              }}
            >
              요청:
              <span>{requestCnt}</span>
            </button>
            <button
              type="button"
              className="possible"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.VALID);
              }}
            >
              가능:
              <span>{possibleCnt}</span>
            </button>
            <button
              type="button"
              className="impossible"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.INVALID);
              }}
            >
              불가능:
              <span>{impossibleCnt}</span>
            </button>
          </div>

          <div>쿠폰 발급에 실패했습니다.</div>
          <div>아래 리스트에서 실패한 결과를 확인하시고,</div>
          <div>
            <span>수정을 한 뒤 다시 시도해주세요.</span>
          </div>
        </div>

        <div className="generate-coupon-valid-fail-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>발급 가능 여부</th>
                <th className="invalid-message">회원 번호</th>
                <th className="invalid-message">휴대전화 번호</th>
                <th className="invalid-message">회원 상태</th>
                <th className="invalid-message">쿠폰 번호</th>
                <th className="invalid-message">쿠폰 발급 수량</th>
              </tr>
            </thead>
            <tbody>
              {userCouponList.filter(validFilter).map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td
                    className={cx('tl', 'result', {
                      isInvalid:
                        item.userIsInvalid ||
                        item.statusIsInvalid ||
                        item.cellPhoneIsInvalid ||
                        item.couponIsInvalid ||
                        item.issuedIsInvalid,
                    })}
                  >
                    {item.userIsInvalid ||
                    item.statusIsInvalid ||
                    item.cellPhoneIsInvalid ||
                    item.couponIsInvalid ||
                    item.issuedIsInvalid
                      ? INVALID_BULK_GENERATE_COUPON_CASE_TEXT
                      : VALID_BULK_GENERATE_COUPON_CASE_TEXT}
                  </td>
                  <td className="tc">
                    {setDash(item.userId)}
                    <div className="message">
                      {item.userIsInvalid ? INVALID_BULK_GENERATE_COUPON_CASE_USER_TYPE_TEXT[item.userInvalidType] : ''}
                    </div>
                  </td>
                  <td className="tc">
                    {setDash(setPhoneFormat(item.cellPhone))}
                    <div className="message">
                      {item.cellPhoneIsInvalid
                        ? INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE_TEXT[item.cellPhoneInvalidType]
                        : ''}
                    </div>
                  </td>
                  <td className="tc">
                    {setDash(ACCOUNT_USER_STATUS_TEXT[item.status])}
                    <div className="message">
                      {item.statusIsInvalid
                        ? INVALID_BULK_GENERATE_COUPON_CASE_USER_STATUS_TYPE_TEXT[item.statusInvalidType]
                        : ''}
                    </div>
                  </td>
                  <td className="tc">
                    {setDash(item.couponId)}
                    <div className="message">
                      {item.couponIsInvalid ? INVALID_BULK_GENERATE_COUPON_CASE_TYPE_TEXT[item.couponInvalidType] : ''}
                    </div>
                  </td>
                  <td className="tc">
                    {setDash(item.issuedCount)}
                    <div className="message">
                      {item.issuedIsInvalid
                        ? INVALID_BULK_GENERATE_COUPON_CASE_ISSUED_TYPE_TEXT[item.issuedInvalidType]
                        : ''}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default GenerateCouponValidFailModal;
